<template>
    <!-- 플랫폼, 마이페이지 -->
    <div>
        <!-- title_cont : S -->
        <MypageSubTitle/>
        <!-- title_cont : E -->
        <div class="ptc_container">
            <MypageWritingSubTitle/>
            <processDetail
                    :processDetailData="processDetailData"
                    v-if="processDetailActive === true"
                    :thisMyPage=true
                    @goToProcessEditor="goToProcessEditor(processDetailData)"
                    @goToProtocolDetail="goToProtocolDetail"
                    @goToList="goToList(0)"
            />
            <protocolDetail
                    :protocolDetailData="protocolDetailData"
                    v-if="processDetailActive === false"
                    :thisMyPage=true
                    @goToProtocolEditor="goToProtocolEditor(protocolDetailData)"
                    @goToProcessDetail="goToProcessDetail(protocolDetailData.processId,0)"
                    @goToProtocolDetail="goToProtocolDetail"
                    @goToList="goToList(1)"
            />
        </div>
        <Loading :visible="loading" type="fixed"></Loading>
        <!-- container : E -->
    </div>
</template>

<script>
    import {commNewMapMutations, commNewMapActions} from "@processEditor/CommNew";
    import MypageSubTitle from "@/views/Platform/Account/MypageSubTitle";
    import MypageWritingSubTitle from "@/views/Platform/Account/MypageWritingSubTitle";
    import processDetail from "@/components/platform_new/processDetail";
    import protocolDetail from "@/components/platform_new/protocolDetail";
    import {typeOfJson} from "@processEditor/CommNew";
    import Loading from '@common/loading.vue'

    export default {
        components: {
            MypageSubTitle,
            MypageWritingSubTitle,
            processDetail,
            protocolDetail,
            Loading,
        },
        data() {
            return {
                loading: false,
                tabIndex: 0,
                viewMode: null,
                processDetailActive: null,
                processId: null,
                processDetailData: {},
                protocolId: null,
                protocolDetailData: {},
            };
        },
        computed: {},
        watch: {
            "$route.query": function(value) {
                this.setOption(value);
                this.setData(this.$route.query?.tabIndex);
            },
        },
        async mounted() {
            this.setOption();
            await this.getMe();
            this.setData(this.$route.query?.tabIndex);
        },
        methods: {
            ...commNewMapActions([
                'getProtocols',
            ]),
            ...commNewMapMutations([
                'setProcessId',
            ]),
            async getMe() {
                // 로그인 여부 확인.
                let userData = await await this.$wApi.user.mypage.me();
                if (userData == null || userData?.error) {
                    this.$router.push("/account/login");
                }
            },
            setOption() {
                if (this.$route.query?.protocolId) {
                    // 프로토콜 관련정보 setting
                    this.protocolId = this.$route.query?.protocolId;
                    this.viewMode = this.$route.query?.viewMode;
                    // 공정도 관련정보 및 이전에 존재할 수 있는 데이터 초기화
                    this.processDetailActive = null;
                    this.processId = null;
                    this.processDetailData = {};
                } else {
                    // 공정도 관련정보 setting
                    this.processId = this.$route.query?.processId;
                    // 프로토콜 관련정보 및 이전에 존재할 수 있는 데이터 초기화
                    this.processDetailActive = null;
                    this.protocolId = null;
                    this.viewMode = null;
                    this.protocolDetailData = {};
                }
            },
            async goToProcessEditor(item) {
                let protocolId = null;
                let category = "process";
                this.setProcessId(item.processId)

                if (category == 'protocol') {
                    const data = await this.getProtocols();
                    protocolId = data[0].keyOfProtocol
                }


                const {href} = this.$router.resolve({
                    path: `/${category}/editor`,
                    query: {
                        processId: item.processId,
                        editorType: category,
                        protocolId: protocolId || null,
                    }
                });
                window.open(href, '_blank');
            },
            async goToProtocolEditor(item) {
                let protocolId = item.protocolId;
                let keyOfProtocol = item.keyOfProtocol;
                let category = "protocol";
                this.setProcessId(item.processId)
                
                const {href} = this.$router.resolve({
                    path: `/${category}/editor`,
                    query: {
                        processId: item.processId,
                        editorType: category,
                        protocolId: protocolId,
                        keyOfProtocol: keyOfProtocol,
                    }
                });
                window.open(href, '_blank');
            },
            async goToProcessDetail(processId, tabIndex) {
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        processId: processId,
                        tabIndex: tabIndex
                    },
                });
            },
            async goToProtocolDetail(protocolId, viewMode, tabIndex, beforeProcessId) {
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        protocolId: protocolId,
                        viewMode: viewMode,
                        tabIndex: tabIndex,
                        beforeProcessId: beforeProcessId,
                    },
                });
            },
            async setData(n){
                if (n == 0) {
                    //공정도 상세화면으로 사용.
                    this.loading = true;
                    // 공정도 정보
                    this.processDetailData = await this.$wApi.process.detail(null, this.processId);
                    // 포함된 프로토콜 정보
                    let protocols = await this.$wApi.process.getProtocols(null, this.processId);
                    if(protocols){
                        protocols = protocols.filter(protocol => protocol.onlyProtocolPublicActive > 0 || protocol.showMode);    
                    }else{
                        protocols = [];
                    }
                    this.processDetailData["protocols"] = protocols; 
                    // userName setting
                    this.processDetailData["userData"] = this.processDetailData["user"];
                    // Thumbnail 정보
                    const thumbnailData = await this.$wApi.process.thumbnail.get(null, this.processId);
                    // Thumbnail setting
                    this.processDetailData["thumbnail"] = thumbnailData.thumbnail;
                    // component 렌더링. (v-if)
                    this.processDetailActive = true;
                    this.loading = false;
                } else if (n == 1) {
                    //프로토콜 상세 화면으로 사용.
                    this.loading = true;
                    let response = await this.$wApi.protocol.searchForProtocoId({
                        protocolId: this.protocolId,
                        isMemo: 0,
                        isComment: 0,
                        isConent: 1,
                        isPublish: 0,
                    });
                    let nodeContents, issues;
                    let info = response[0];
                    if (response[0].nodeContent) nodeContents = JSON.parse(response[0].nodeContent);
                    issues = typeOfJson(info.json)
                    let shortValues = [];
                    for (let issue of issues.issues) {
                        delete issue.child;
                        if (nodeContents) {
                            if (issue.V === true && nodeContents[issue.key] && nodeContents[issue.key].replace(/(<([^>]+)>)/gi, '') != "") {
                                shortValues.push({
                                    display: issue.display,
                                    isSelected: true,
                                    key: issue.key + '-shortValue',
                                    parent: issue.key,
                                    category: 'SHORTVALUE',
                                    visible: false,
                                    text: nodeContents[issue.key].replace(/(<([^>]+)>)/gi, '')
                                })
                            }
                        }
                    }
                    if (shortValues.length > 0) issues.issues.push(...shortValues)
                    this.protocolDetailData = info;
                    this.protocolDetailData.json = issues;
                    this.protocolDetailData.viewType = this.viewMode;
                    // component 렌더링. (v-else)
                    this.processDetailActive = false;
                    this.loading = false;
                }
            },
            goToList(tabIndex){
                this.$router.push({
                    path: "/account/mypage/createdList",
                    query: {
                        tabIndex: tabIndex,
                    }
                });
            }
        },
    };
</script>
